import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import colors from 'seagull/foundations/colors.module.scss';
const iconColors = {
    error: colors.red970,
    success: colors.green900,
    pending: colors.dark500
};
export const AccountingMappingIcon = (props)=>{
    const { size = 16, intent = 'success', testId } = props, rest = _object_without_properties(props, [
        "size",
        "intent",
        "testId"
    ]);
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        width: size,
        height: size,
        viewBox: "0 0 13 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        "data-testid": testId || "accounting-mapping-icon-".concat(intent),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.5505 8.36995L9.79008 5.45712C9.63365 5.29273 9.38042 5.29315 9.22439 5.45712C9.06796 5.6211 9.06796 5.88744 9.22439 6.05142L11.3047 8.24676H5.06655C4.84571 8.24676 4.6665 8.43489 4.6665 8.66712C4.6665 8.89935 4.84575 9.08747 5.06655 9.08747H11.3047L9.22439 11.2828C9.06796 11.4472 9.06796 11.7131 9.22439 11.8771C9.38082 12.0415 9.63405 12.0415 9.79008 11.8771L12.5501 8.96428C12.7045 8.8028 12.7061 8.53185 12.5505 8.36995Z",
                strokeWidth: "1",
                fill: iconColors[intent]
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.36156 3.75343H7.6C7.82085 3.75343 8.00007 3.56532 8.00007 3.3331C8.00007 3.10088 7.82082 2.91277 7.6 2.91277H1.36156L3.44198 0.717546C3.59842 0.553164 3.59842 0.287254 3.44198 0.123287C3.28555 -0.0410955 3.0323 -0.0410955 2.87627 0.123287L0.11613 3.03595C-0.0379109 3.19784 -0.0395072 3.46877 0.11613 3.63063L2.87667 6.54329C3.0331 6.70767 3.28635 6.70726 3.44238 6.54329C3.59882 6.37932 3.59882 6.113 3.44238 5.94903L1.36156 3.75343Z",
                strokeWidth: "1",
                fill: iconColors[intent]
            })
        ]
    }));
};
